import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatNumber } from "../../utils/common";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

function BarVeriticalElections({ data, selectedYear, t }) {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const reversedData = [...data].reverse();
  const labels = reversedData.map((item) => item.year);
  const dataObj = reversedData.map((item) => Math.floor(item.partyVotes));

  const backgroundColors = reversedData.map((item) =>
    item.year === selectedYear ? "#E88B00" : "#0080B7"
  );

  const chartData = {
    labels,
    datasets: [
      {
        label: t("voteShare"),
        data: dataObj,
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20, // adjust this value as needed to provide enough room for the labels
      },
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
          drawBorder: false,
          display: false,
        },
        ticks: {
          color: "black",
        },
      },
      y: {
        ticks: {
          display: true,
        },
        grid: {
          drawBorder: false,
          display: false, // This hides the horizontal grid lines
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += formatNumber(context.parsed.y, language);
            }
            return label;
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "top",
        formatter: function (value, context) {
          return formatNumber(value, language);
        },
        color: "black",
      },
    },
  };

  return <Bar options={options} data={chartData} />;
}

export default BarVeriticalElections;
